import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationService } from 'src/app/services/navigation.service'; 
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';


@Component({
  selector: 'app-anios-d',
  templateUrl: './anios-d.component.html',
  styleUrls: ['./anios-d.component.css']
})
export class AniosDComponent {

    anio = {
      seleccion: '',
      id:''
    }
  
    opE: any;
    token: any;
    retrievedArea: any;
    rol: any;
  
    // declaración de los mensajes de validación 
    showErrorMessageAcronimo : boolean = false;
    showErrorMessageNombre   : boolean = false;
    mensajeValidacionAcronimo: string  = '';
    mensajeValidacionNombre  : string  = '';
    mensaje                  : string  = 'Campo requerido.';
  
    iconoMostrar: string = '';
    nameBoton: string = '';
  
    constructor(
      private router: Router,
      private route: ActivatedRoute,
      private sharedService: SharedService,
      private requestsService: CatalogsService,
      private messagesService: MessagesService,
      private navigationService: NavigationService,
      private filtrarProyectosService: FiltrarProyectosService) { }
  
    ngOnInit() {
      this.verificacionUsuario();  
      this.obtnerIcono();
    }
  
    obtnerIcono(){
      this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
      this.nameBoton = this.opE === '1' ? 'Regresar' : 'Cancelar';
    }
  
    verificacionUsuario(){
      const { rol, token } = this.filtrarProyectosService.validacionUsuarios();
      this.rol = rol;
      this.token = token;
      this.navigationService.disableNavigation();
      this.opE = this.route.snapshot.paramMap.get('datos');
      
      if (this.opE === '1') {//obtendgo creditor para actualizar
        this.retrievedArea = this.sharedService.getDataArray();
        this.cargarArea(this.retrievedArea);
      }
    }
  
    async cargarArea(getanio: any) {
      this.anio.seleccion = getanio.anio;
      this.anio.id = getanio.id_anio;
    }
  
    async validaFormulario(guardar: any, editar: any) {
      if ( this.anio.seleccion === '') {
        this.messagesService.showError('Campos son obligatorios');
        return;
      }
      if (guardar === true) {
        this.guardar()
      }
      if (editar === true) {
        this.editar()
      }
    }
  
    editar() {
      this.requestsService.editYears(this.token, this.anio).subscribe(
        (res) => {
          this.navegarMensaje(res.message);
        },(err) => {
          this.messagesService.showError(err.error.error[0].message);
        }
      )
    }
  
    guardar() {
      this.requestsService.createYears(this.token, this.anio.seleccion).subscribe(
        (res) => {
          this.navegarMensaje(res.message);
        },(err) => {
          this.messagesService.showError(err.error.message);
        }
      )
    }
  
    eliminar() {
      this.requestsService.deleteYears(this.token, this.anio.id).subscribe(
        (res) => {
          this.navegarMensaje(res.message);
        },(err) => {
          this.messagesService.showError(err.error.error[0].message);
        }
      )
    }
  
    navegarMensaje(res: any){
      this.messagesService.showMessage(res);
      this.cancelar();
    }
  
    cancelar() {
      this.router.navigate(['/anios']);
    }
  
    private isNumber(value: any): boolean {
      return !isNaN(parseFloat(value)) && isFinite(value);
    }
  
    private isValidEmail(email: string): boolean {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(email);
    }
  
    // mensajes de validación 
    mostrarMensaje(campo: any, tipo: string) {
      if (tipo === 'acronimo') {
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageAcronimo = true;
          this.mensajeValidacionAcronimo = this.mensaje;
        } else {
          this.showErrorMessageAcronimo = false;
        }
      } else if (tipo === 'seleccion') {
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageNombre = true;
          this.mensajeValidacionNombre = this.mensaje;
        } else {
          this.showErrorMessageNombre = false;
        }
      }
    }

}
